export function getUrlParamOrLocalStorage(
  paramKey: string,
  searchParams: URLSearchParams
) {
  let returnValue;
  if (searchParams.get(paramKey)) {
    returnValue = searchParams.get(paramKey);
  } else if (localStorage.getItem(paramKey)) {
    returnValue = localStorage.getItem(paramKey);
  }
  return returnValue;
}
